// extracted by mini-css-extract-plugin
module.exports = {"paper":"stores-list_paper__1VwMr","text":"stores-list_text__3JALH","inline":"stores-list_inline__3P65E"};